import { Space, Tag } from 'antd';
import BooleanIcons from 'common/ui/boolean-icons';
import { Check, EyeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { formatDate, formatDateTime } from 'utils/formatDate';
import { getChangeValueColor } from './color';
import { formatCurrency, formatUnitQuantity } from './formatAmount';

export const dateTimeCell = ({ getValue }) => {
  const value = getValue();
  return (
    <div className="text-right flex justify-end">
      <div className="max-w-24">{formatDateTime(value)}</div>
    </div>
  );
};
export const dateCell = ({ getValue }) => {
  const value = getValue();
  return <div className="text-right">{formatDate(value)}</div>;
};
export const checkIconWithValueCell = ({ getValue }) => {
  const value = getValue();
  return (
    value && (
      <Space>
        <Check color="green" size={18} className="mt-1.5" />
        {value}
      </Space>
    )
  );
};
export const numberCell = ({ getValue }) => {
  const value = getValue();
  return (
    <div className="text-right">
      {isNaN(value) ? '-' : formatUnitQuantity(value)}
    </div>
  );
};
export const currencyCell = ({ getValue }) => {
  const value = getValue();
  return (
    <div className="text-right">
      {formatCurrency(value)?.replace(/[^0-9.,-]/g, '')}
    </div>
  );
};

export const profitLossCell = ({ row }) => {
  const amount = row.original?.unrealized_gain_loss_amount;
  const percentage = row.original?.unrealized_gain_loss_percentage;

  if (!amount && !percentage) return '-';
  const color = getChangeValueColor(percentage);
  return (
    <div className="text-right flex flex-col items-end font-semibold">
      <div style={{ color }}>{formatUnitQuantity(amount)}</div>
      <Tag color={color} className="-mr-1">
        {formatUnitQuantity(percentage)}%
      </Tag>
    </div>
  );
};

export const upperCaseCell = ({ getValue }) => {
  const value = getValue();
  return value ? value.toUpperCase() : '-';
};

export const linkCell = ({ getValue, path }) => {
  const id = getValue();

  return (
    <Link to={`${path}/${id}`}>
      <EyeIcon />
    </Link>
  );
};

export const userCell = ({ getValue }) => {
  const user = getValue();
  if (!user) return null;
  return (
    <Link to={`/investment/users/${user?.id}`}>
      <div>{user?.name ?? ''}</div>
      <div>{user?.email ?? ''}</div>
    </Link>
  );
};

export const booleanCell = ({ getValue }) => (
  <div className="mx-auto w-fit">
    <BooleanIcons value={getValue()} />
  </div>
);
